import React, { useState, useEffect, useRef } from 'react';
import styled from '@emotion/styled';
import { Box, CardMedia, Typography } from '@mui/material';
import tg from '../../../assets/tg.svg';
import sectbot from '../../../assets/sectbot.svg';
import nifinity from '../../../assets/nifinity.svg';
import Arrowleft from '../../../assets/Arrowleft.svg';
import Arrowright from '../../../assets/Arrowright.svg';
import Heading from '../../Components/LockerMenu/component/Heading';
import topup from '../../../assets/topup.png';
import amazaonicon from '../../../assets/amazonicon.png'

const Wrapper = styled(Box)`
  padding: 120px 0px;
  position: relative;
`;

const ProjectCard = styled(Box)`
  background: #f4faff;
  border: 3px solid #d5ecff;
  border-radius: 21px;
  padding: 30px;
  cursor: pointer;
  width: 100%;
  text-align: left;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
`;

const CategoryText = styled(Typography)`
  font-size: 16px;
  color: #666;
  margin-bottom: 2px;
`;

const ProjectName = styled(Typography)`
  font-size: 24px;
  font-weight: 600;
  color: #000;
`;

const SliderContainer = styled(Box)`
  position: relative;
  width: 100%;
  overflow: hidden;
`;

const SliderWrapper = styled(Box)`
  display: flex;
  transition: transform 0.5s ease;
`;

const NavigationButton = styled(Box)`
  background: #f4faff;
  border: 3px solid #d5ecff;
  border-radius: 22px;
  width: 80px;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #d5ecff;
  }
`;

const NavigationContainer = styled(Box)`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 40px;
`;

const OverlayLeft = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 130px;
  background: linear-gradient(to right, #fff 30%, transparent);
  z-index: 2;
  pointer-events: none;

  @media (max-width: 768px) {
    display: none;
  }
`;

const OverlayRight = styled(Box)`
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 190px;
  background: linear-gradient(to left, #fff 30%, transparent);
  z-index: 2;
  pointer-events: none;

  @media (max-width: 768px) {
    display: none;
  }
`;

const Projects = () => {
  const projects = [
    { 
      category: 'Social', 
      name: 'Telegram', 
      image: tg,
      url: 'https://app.aicm.store/services-telegram'  
    },
    { 
      category: 'Social', 
      name: 'Mobile TopUp', 
      image: topup,
      url: 'https://app.aicm.store/services-topup'  
    },
    { 
      category: 'Social', 
      name: 'Amazon', 
      image: amazaonicon,
      url: 'https://app.aicm.store/services-amazon'  
    },
    { 
      category: 'Social', 
      name: 'NFINITY', 
      image: nifinity,
      url: 'https://app.aicm.store/services-nfinity' 
    },
    // { 
    //   category: 'Business', 
    //   name: 'Sectbot', 
    //   image: sectbot,
    //   url: 'https://app.aicm.store/services-sectbot' 
    // },
    { 
      category: 'Social', 
      name: 'Telegram', 
      image: tg,
      url: 'https://app.aicm.store/services-telegram'  
    },
    // { 
    //   category: 'Business', 
    //   name: 'Sectbot', 
    //   image: sectbot,
    //   url: 'https://app.aicm.store/services-sectbot' 
    // },
    { 
      category: 'Social', 
      name: 'NFINITY', 
      image: nifinity,
      url: 'https://app.aicm.store/services-nfinity' 
    },
  ];


  const [currentIndex, setCurrentIndex] = useState(0);
  const [cardsToShow, setCardsToShow] = useState(4);
  const [isTransitioning, setIsTransitioning] = useState(true);
  const autoSlideRef = useRef(null);

  
  const clonedProjects = [...projects, ...projects, ...projects];

  
  useEffect(() => {
    const updateVisibleCards = () => {
      if (window.innerWidth <= 768) {
        setCardsToShow(1);  // Show 1 card on mobile
      } else if (window.innerWidth <= 1024) {
        setCardsToShow(2);  // Show 2 cards on tablet
      } else {
        setCardsToShow(4.1);  // Show 4 cards on larger screens
      }
    };

    updateVisibleCards();
    window.addEventListener('resize', updateVisibleCards);
    return () => window.removeEventListener('resize', updateVisibleCards);
  }, []);


  useEffect(() => {
    autoSlideRef.current = setInterval(() => {
      handleNext();
    }, 3000);

    return () => {
      if (autoSlideRef.current) {
        clearInterval(autoSlideRef.current);
      }
    };
  }, [cardsToShow]);

  const handlePrev = () => {
    setIsTransitioning(true);
    setCurrentIndex(prev => {
      if (prev <= 0) {
        setTimeout(() => {
          setIsTransitioning(false);
          setCurrentIndex(projects.length);
        }, 500);
        return projects.length - 1;
      }
      return prev - 1;
    });
  };

  const handleNext = () => {
    setIsTransitioning(true);
    setCurrentIndex(prev => {
      if (prev >= projects.length * 2 - cardsToShow) {
        setTimeout(() => {
          setIsTransitioning(false);
          setCurrentIndex(projects.length - cardsToShow);
        }, 500);
        return projects.length * 2;
      }
      return prev + 1;
    });
  };
  const handleProjectClick = (url) => {
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };



  const getActualIndex = (index) => index % projects.length;

  return (
    <Wrapper>
      <Box textAlign="center" mb={6}>
        <Heading>Listed Projects</Heading>
      </Box>

      <SliderContainer>
        <OverlayLeft />
        <OverlayRight />
        <SliderWrapper
          style={{transform: `translateX(-${(currentIndex * 100) / cardsToShow}%)`,transition: isTransitioning ? 'transform 0.5s ease' : 'none',}}>
          {clonedProjects.map((project, index) => (
            <Box
              key={`${getActualIndex(index)}-${Math.floor(index / projects.length)}`}
              sx={{flex: `0 0 ${(100 / cardsToShow)}%`,padding: '0 10px',boxSizing: 'border-box',}}>
              <ProjectCard onClick={() => handleProjectClick(project.url)}>
                {project.image && (
              <CardMedia
              style={{width: '100%',maxWidth: '50px',height: 'auto',marginBottom: '15px',borderRadius: project.name === 'Mobile TopUp' ? '12px' : '0', }}
              component="img"
              alt={project.name}
              image={project.image}
              draggable='false'/>
            
                )}
                <CategoryText>{project.category}</CategoryText>
                <ProjectName>{project.name}</ProjectName>
              </ProjectCard>
            </Box>
          ))}
        </SliderWrapper>
      </SliderContainer>

      <NavigationContainer>
        <NavigationButton onClick={handlePrev}>
          <img src={Arrowleft} alt="Previous" />
        </NavigationButton>
        <NavigationButton onClick={handleNext}>
          <img src={Arrowright} alt="Next" />
        </NavigationButton>
      </NavigationContainer>

    </Wrapper>
  );
};

export default Projects;
